import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaConnectSteps',
			dom: {
				portlet: '#yotaConnect',
				step: '.js-connect-steps-step',
				sim: '[data-step="sim"]',
				info: '[data-step="info"]',
				docs: '[data-step="docs"]'
			},
			classes: {
				active: 'b-connect-steps__step_state_active',
				complete: 'b-connect-steps__step_state_complete',
				steps: {
					sim: 'b-connect_state_sim',
					info: 'b-connect_state_info',
					docs: 'b-connect_state_docs',
					thank: 'b-connect_state_thank'
				}
			},
			data: {
				sim: {
					active: false,
					complete: false
				},
				info: {
					active: false,
					complete: false
				},
				docs: {
					active: false,
					complete: false
				}
			}
		};
		this.options = $.extend(true, {}, defaults, options);
		this.data = this.options.data;
		this.$el = (this.options.el instanceof $) ? this.options.el : $(this.options.el);
		return this;
	}

	getDom() {
		this.$portlet = $(this.options.dom.portlet);
		this.$sim = this.$el.find(this.options.dom.step + this.options.dom.sim);
		this.$info = this.$el.find(this.options.dom.step + this.options.dom.info);
		this.$docs = this.$el.find(this.options.dom.step + this.options.dom.docs);
		return this;
	}

	update(data) {
		const self = this;
		if (typeof data !== 'undefined') {
			self.data = data;
		}

		let step = 'sim';
		$.each(self.data, function (name, options) {
			self['$' + name]
				.toggleClass(self.options.classes.active, options.active)
				.toggleClass(self.options.classes.complete, options.complete);
			if (options.active) {
				step = name;
				if (name === 'docs' && options.complete) {
					step = 'thank';
				}
			}
		});
		$.each(self.options.classes.steps, function (name, txt) {
			self.$portlet.toggleClass(txt, name == step);
		});

		return self;
	}

	render() {
		if (this.$el.length) {
			this
				.getDom()
				.update();
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/connect/steps/steps.js